<script lang="ts">
  import { Nomina, type Empleado, type Planilla } from '../lib/api';

  let empleados = $state<Empleado[]>([]);
  let planillas = $state<Planilla[]>([]);
  let detalle = $state<any[]>([]);
  let planSel = $state<string>('');
  let error = $state<string|null>(null);

  let nuevoEmp = $state<Empleado>({ codigo:'', nombres:'', apellidos:'', salarioBase:0, bonificacion:250, activo:true, fechaIngreso: new Date().toISOString().slice(0,10) });
  let editandoEmpId = $state<string | null>(null);
  let nuevaPlan = $state<Planilla>({ tipo:'FIN_DE_MES', periodo: new Date().toISOString().slice(0,7) });

  async function cargar() {
    try { empleados = (await Nomina.empleados()).filter(e => e.activo); planillas = await Nomina.planillas(); }
    catch (e:any) { error = e?.message; }
  }
  function editarEmp(e: Empleado) {
    editandoEmpId = e.id ?? null;
    nuevoEmp = { codigo: e.codigo, nombres: e.nombres, apellidos: e.apellidos, puesto: e.puesto ?? '', departamento: e.departamento ?? '', salarioBase: Number(e.salarioBase), bonificacion: Number(e.bonificacion ?? 250), activo: e.activo ?? true, fechaIngreso: e.fechaIngreso ?? new Date().toISOString().slice(0,10) };
  }
  function cancelarEmp() { editandoEmpId = null; nuevoEmp = { codigo:'', nombres:'', apellidos:'', salarioBase:0, bonificacion:250, activo:true, fechaIngreso: new Date().toISOString().slice(0,10) }; }

  async function guardarEmp(e: SubmitEvent) { e.preventDefault();
    try {
      if (editandoEmpId) { await Nomina.actualizarEmp(editandoEmpId, { ...nuevoEmp }); }
      else { await Nomina.crearEmp({ ...nuevoEmp }); }
      nuevoEmp = { codigo:'', nombres:'', apellidos:'', salarioBase:0, bonificacion:250, activo:true, fechaIngreso: new Date().toISOString().slice(0,10) }; editandoEmpId = null;
      await cargar();
    } catch (e:any) { error = e?.message; }
  }
  async function crearPlan(e: SubmitEvent) { e.preventDefault();
    try { await Nomina.crearPlan({ ...nuevaPlan }); await cargar(); } catch (e:any) { error = e?.message; }
  }
  async function calcular(id: string) { try { await Nomina.calcular(id); await cargar(); if (planSel===id) detalle = await Nomina.detalle(id); } catch (e:any) { error = e?.message; } }
  async function autorizar(id: string) { try { await Nomina.autorizar(id); await cargar(); } catch (e:any) { error = e?.message; } }
  async function pagar(id: string)    { try { await Nomina.pagar(id); await cargar(); } catch (e:any) { error = e?.message; } }
  async function verDetalle(id: string) { planSel = id; try { detalle = await Nomina.detalle(id); } catch (e:any) { error = e?.message; } }
  async function eliminarEmp(e: Empleado) {
    if (!confirm(`¿Eliminar a ${e.nombres} ${e.apellidos}?`)) return;
    try { await Nomina.eliminarEmp(e.id!); await cargar(); } catch (e:any) { error = e?.message; }
  }

  $effect(() => { cargar(); });
</script>

<section>
  <header class="view-header">
    <div><h2>Nómina hospitalaria (Guatemala)</h2><p class="muted">Empleados, planillas y cálculo de nómina</p></div>
    <button onclick={cargar}>Recargar</button>
  </header>
  {#if error}<p class="err">⚠ {error}</p>{/if}

  <h3>Empleados</h3>
  <form onsubmit={guardarEmp} class="row">
    <label class="field"><span>Código</span><input placeholder="Código" bind:value={nuevoEmp.codigo} required style="width:110px"/></label>
    <label class="field"><span>Nombres</span><input placeholder="Nombres" bind:value={nuevoEmp.nombres} required/></label>
    <label class="field"><span>Apellidos</span><input placeholder="Apellidos" bind:value={nuevoEmp.apellidos} required/></label>
    <label class="field"><span>Puesto</span><input placeholder="Puesto" bind:value={nuevoEmp.puesto}/></label>
    <label class="field"><span>Fecha ingreso</span><input type="date" bind:value={nuevoEmp.fechaIngreso} required style="width:150px"/></label>
    <label class="field"><span>Salario base</span><input type="number" step="0.01" placeholder="Salario base" bind:value={nuevoEmp.salarioBase} required style="width:130px"/></label>
    <label class="field"><span>Bonif.</span><input type="number" step="0.01" placeholder="Bonif." bind:value={nuevoEmp.bonificacion} style="width:90px"/></label>
    <button type="submit">{editandoEmpId ? 'Guardar' : 'Agregar'}</button>
    {#if editandoEmpId}<button type="button" class="ghost" onclick={cancelarEmp}>Cancelar</button>{/if}
  </form>
  <table>
    <thead><tr><th>Código</th><th>Nombre</th><th>Puesto</th><th>Salario</th><th>Bonif.</th><th></th></tr></thead>
    <tbody>
      {#each empleados as e (e.id)}
        <tr><td>{e.codigo}</td><td>{e.nombres} {e.apellidos}</td><td>{e.puesto ?? ''}</td><td>Q {Number(e.salarioBase).toFixed(2)}</td><td>Q {Number(e.bonificacion ?? 0).toFixed(2)}</td><td><button type="button" class="link" onclick={() => editarEmp(e)}>Editar</button> <button type="button" class="link" onclick={() => eliminarEmp(e)}>Eliminar</button></td></tr>
      {:else}<tr><td colspan="6" class="empty">Sin empleados.</td></tr>{/each}
    </tbody>
  </table>

  <h3>Planillas</h3>
  <form onsubmit={crearPlan} class="row">
    <label class="field"><span>Tipo</span>
      <select bind:value={nuevaPlan.tipo}><option>QUINCENA</option><option>FIN_DE_MES</option><option>BONO_14</option><option>AGUINALDO</option><option>EXTRA</option></select>
    </label>
    <label class="field"><span>Periodo</span><input placeholder="Periodo YYYY-MM" bind:value={nuevaPlan.periodo} required style="width:130px"/></label>
    <button type="submit">Crear</button>
  </form>
  <table>
    <thead><tr><th>Número</th><th>Periodo</th><th>Tipo</th><th>Estado</th><th>Bruto</th><th>Neto</th><th>Acciones</th></tr></thead>
    <tbody>
      {#each planillas as p (p.id)}
        <tr class:sel={p.id===planSel}>
          <td>{p.numero ?? ''}</td><td>{p.periodo}</td><td>{p.tipo}</td><td>{p.estado}</td>
          <td>Q {Number(p.totalBruto ?? 0).toFixed(2)}</td><td>Q {Number(p.totalNeto ?? 0).toFixed(2)}</td>
          <td>
            <button onclick={() => verDetalle(p.id!)}>Detalle</button>
            {#if p.estado === 'BORRADOR'}<button onclick={() => calcular(p.id!)}>Calcular</button>{/if}
            {#if p.estado === 'CALCULADA'}<button onclick={() => autorizar(p.id!)}>Autorizar</button>{/if}
            {#if p.estado === 'AUTORIZADA'}<button onclick={() => pagar(p.id!)}>Pagar</button>{/if}
          </td>
        </tr>
      {:else}<tr><td colspan="7" class="empty">Sin planillas.</td></tr>{/each}
    </tbody>
  </table>

  {#if planSel && detalle.length > 0}
    <h3>Detalle de planilla</h3>
    <table>
      <thead><tr><th>Empleado</th><th>Bruto</th><th>IGSS</th><th>ISR</th><th>Otras</th><th>Neto</th></tr></thead>
      <tbody>
        {#each detalle as d (d.id)}<tr><td>{d.empleadoNombre ?? d.empleadoId}</td><td>Q {Number(d.totalBruto).toFixed(2)}</td><td>Q {Number(d.igss).toFixed(2)}</td><td>Q {Number(d.isr).toFixed(2)}</td><td>Q {Number(d.otrasDeducciones ?? 0).toFixed(2)}</td><td>Q {Number(d.neto).toFixed(2)}</td></tr>{/each}
      </tbody>
    </table>
  {/if}
</section>

<style>
  .view-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; flex-wrap: wrap; margin-bottom: 1rem; }
  .view-header h2 { margin: 0; font-size: 1.4rem; color: #111827; }
  .muted { margin: 0.2rem 0 0; color: #6b7280; font-size: 0.85rem; }
  button { padding: .5rem .9rem; border: 0; background: linear-gradient(135deg, #15803d, #16a34a); color: #fff; border-radius: 8px; cursor: pointer; font: inherit; font-weight: 600; box-shadow: 0 4px 14px rgba(22,163,74,0.3); transition: transform 0.15s; }
  button:hover { transform: translateY(-1px); }
  .row { display: flex; gap: .75rem; flex-wrap: wrap; margin: 1rem 0; align-items: flex-end; }
  .field { display: flex; flex-direction: column; gap: .3rem; }
  .field span { font-size: .72rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: .03em; }
  .row input, .row select { padding: .5rem .65rem; border-radius: 8px; border: 1px solid #e5e7eb; font: inherit; background: #fff; color: #111827; }
  .row input:focus, .row select:focus { outline: none; border-color: #16a34a; box-shadow: 0 0 0 3px rgba(22,163,74,0.12); }
  table { width: 100%; border-collapse: collapse; margin-bottom: 1rem; }
  th { text-align: left; font-size: .7rem; text-transform: uppercase; letter-spacing: .03em; color: #6b7280; padding: .55rem .8rem; background: #f0fdf4; }
  td { padding: .5rem .8rem; border-top: 1px solid #f3f4f6; text-align: left; font-size: .9rem; color: #111827; }
  tr.sel { background: #f0fdf4; }
  .err { color: #dc2626; } .empty { color: #9ca3af; text-align: center; font-style: italic; }
  h3 { margin-top: 1.5rem; font-size: 1rem; color: #166534; }
  td button { padding: .25rem .55rem; font-size: .8rem; border-radius: 6px; border: 1px solid #e5e7eb; background: #fff; color: #16a34a; cursor: pointer; margin-right: .2rem; box-shadow: none; font-weight: 500; }
  td button:hover { background: #f0fdf4; transform: none; }
</style>
